import React, { useState } from "react";
import myImg from "../../Assets/dip.jpg";
import Rotate from 'react-reveal/Rotate';
import Flip from 'react-reveal/Flip';
import "./styles.css";

function Profile(props) {
  var today = new Date();
  var birthDate = new Date('1998');
  return (
    <section id="about" class="about px-5">
      <div class="container px-5">
        <div class="section-title">
          <h2>About</h2>
          <p>
              Over <strong>2.0 years</strong> of strong experience as{" "}
              <strong>MERN Stack</strong> web developer with a solid
              understanding of front-end technologies,{" "}
              <strong>MVC frameworks</strong>, and{" "}
              <strong>Restful web services</strong>. Strong
              knowledge in MEN/MEAN Stack with vast experience in building Web
              Applications, used <strong>React /Angular</strong> for
              client-side, <strong>Node.js/Express</strong> for server-side and
              MongoDB, SQL Server for database.
            </p>
        </div>

        <div class="row">
          <div class="col-lg-4">
            <div class="p-5 py-2">
              <img class="img-fluid rounded-circle" src={myImg} alt="..." />
            </div>
          </div>
          {/* <div class="col-lg-4" data-aos="fade-right">
        <img src={myImg } class="img-fluid" alt="" />
      </div> */}
          <div class="col-lg-8 pt-4 pt-lg-0 content" data-aos="fade-left">
          <Rotate top left><h3>Software Engineer</h3></Rotate>
            <p class="font-italic"></p>
            <div class="row">
              <div class="col-lg-6">
                <ul>
                <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i>{" "}
                    <strong>Birthday:</strong> <span>17 Aug 1998</span>
                  </li>
                  </Flip>
                  <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i> <strong>Strem:</strong>{" "}
                    <span>I.T</span>
                  </li>
                  </Flip>
                  <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i> <strong>Phone:</strong>{" "}
                    <span>+918001388527</span>
                  </li>
                  </Flip>
                  <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i> <strong>City:</strong>{" "}
                    <span>Kolkata, IND</span>
                  </li>
                  </Flip>
                </ul>
              </div>
              <div class="col-lg-6">
                <ul>
                <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i> <strong>Age:</strong>{" "}
                    <span>{ today.getFullYear() - birthDate.getFullYear()}</span>
                  </li>
                  </Flip>
                  <Flip left>
                  <li>
                  
                    <i class="bi bi-chevron-right"></i> <strong>Degree:</strong>{" "}
                    <span>B.E</span>
                    
                  </li>
                  </Flip>
                  <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i> <strong>Email:</strong>{" "}
                    <span>dipamhalder0@gmail.com</span>
                  </li>
                  </Flip>
                  <Flip left>
                  <li>
                    <i class="bi bi-chevron-right"></i>{" "}
                    <strong>Freelance:</strong> <span>Available</span>
                  </li>
                  </Flip>
                </ul>
              </div>
            </div>
         
          </div>
        </div>
      </div>
    </section>

    
  );
}
export default Profile;
